import {hexToRgb} from './hexToRgb';
import {HexColor, HsvColor} from './colorTypes';
import {rgbToHsv} from './rgbToHsv';

/**
 * @name hexToHsv
 * @description Converts a hex code into HSV format
 */
export const hexToHsv = (hex: HexColor): HsvColor => {
  const rgb = hexToRgb(hex);
  return rgbToHsv(rgb);
};
